import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { PelicanCircle } from '../icons/icons';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import { HTMLTemplateResult } from 'lit-html';

type OwnDeps = {
  questionsService: QuestionsService;
};

@requires(QuestionsService.serviceName)
@customElement('non-eligible-popup-add-boat')
export class NonEligablePopupAddBoat extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
        .title {
          font-weight: 700;
          font-size: 4rem;
        margin-bottom: 1.75rem;
      }

      .sub-title {
        font-size: 4rem;
        font-weight: 700;
        margin-bottom: 2rem;
        line-height: 4rem;
        color: var(--c-text-sub);
      }

      .message {
        font-weight: 400;
        max-width: var(--message-max-width, 39rem);
        color: var(--c-text);
      }

      svg, img {
        max-width: 26.5rem;
        max-height: 36.5rem;
      }
    `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  @property({ type: String })
    value: string = '';

  renderMobileLayout(title: string, messages: HTMLTemplateResult) {
    return html`
      <div class="">
        <div class="popup-image-container">
          ${PelicanCircle}
        </div>
        <div class="col-1">
          <h2 class="title">${title}</h2>
        </div>
        <div class="col-3">
          ${messages}
        </div>


      </div>
    `;
  }

  renderDesktopLayout(title: string, messages: HTMLTemplateResult) {
    return html`
      <div class="grid-container">
        <div class="col-1"></div>
        <div class="col-2">
          <h1 class="title">${title}</h1>
          ${messages}
        </div>
      </div>
    `;
  }

  renderContent() {
    const title = t('T_Add_Boat');
    const messages = html`<h2 class="message">${unsafeHTML(this.value)}</h2>`;
    return this.userDevice === 'desktop' ? this.renderDesktopLayout(title, messages) : this.renderMobileLayout(title, messages);
  }
}